import React from 'react';

export default function AiInterruptWarningModal({ isOpen, onClose, onConfirmLeave }) {
  if (!isOpen) return null;

  return (
    <div
      className="cmp-modal-backdrop"
      onClick={onClose}
      style={{
        zIndex: 1100,
        backgroundColor: 'rgba(15, 23, 42, 0.65)',
        backdropFilter: 'blur(4px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
        boxSizing: 'border-box',
      }}
    >
      <div
        className="cmp-modal-container"
        style={{
          width: '100%',
          maxWidth: '520px',
          background: '#ffffff',
          borderRadius: '14px',
          overflow: 'hidden',
          boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.25)',
          border: '1px solid #e2e8f0',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Modal Header */}
        <div
          style={{
            padding: '16px 20px',
            borderBottom: '1px solid #e2e8f0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: '#ffffff',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div
              style={{
                width: '36px',
                height: '36px',
                borderRadius: '8px',
                background: '#fffbeb',
                border: '1px solid #fde68a',
                color: '#d97706',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '15px',
                flexShrink: 0,
              }}
            >
              <i className="fas fa-exclamation-triangle" />
            </div>
            <div>
              <h3 style={{ fontSize: '15px', fontWeight: 700, color: '#0f172a', margin: 0 }}>
                Interrupt AI Generation?
              </h3>
              <p style={{ fontSize: '12px', color: '#64748b', margin: '2px 0 0 0' }}>
                An active AI synthesis process is currently running.
              </p>
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            title="Close modal"
            style={{
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              color: '#64748b',
              width: '28px',
              height: '28px',
              borderRadius: '6px',
              fontSize: '13px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.15s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = '#0f172a';
              e.currentTarget.style.background = '#f1f5f9';
              e.currentTarget.style.borderColor = '#cbd5e1';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = '#64748b';
              e.currentTarget.style.background = '#f8fafc';
              e.currentTarget.style.borderColor = '#e2e8f0';
            }}
          >
            <i className="fas fa-times" />
          </button>
        </div>

        {/* Modal Body */}
        <div
          style={{
            padding: '18px 20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '14px',
            background: '#ffffff',
          }}
        >
          {/* AI In Progress Alert Card with Dribbble Animation */}
          <div
            style={{
              background: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: '10px',
              padding: '14px 16px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: '14px',
            }}
          >
            {/* Animated Dribbble AI Star Badge */}
            <div
              style={{
                width: '32px',
                height: '32px',
                borderRadius: '8px',
                background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 55%, #eef2ff 100%)',
                border: '1.5px solid #c7d2fe',
                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.05), 0 0 8px rgba(99, 102, 241, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#2563eb',
                flexShrink: 0,
                marginTop: '1px',
              }}
            >
              <svg className="cmp-dribbble-svg" viewBox="0 0 28 28" width="16" height="16">
                <path
                  className="cmp-dribbble-main-star"
                  d="M14 3.5C14 9.299 9.299 14 3.5 14C9.299 14 14 18.701 14 24.5C14 18.701 18.701 14 24.5 14C18.701 14 14 9.299 14 3.5Z"
                  fill="currentColor"
                />
                <circle
                  className="cmp-dribbble-sat-1"
                  cx="21.5"
                  cy="6.5"
                  r="1.5"
                  fill="currentColor"
                />
                <circle
                  className="cmp-dribbble-sat-2"
                  cx="6.5"
                  cy="21.5"
                  r="1.3"
                  fill="currentColor"
                />
                <circle
                  className="cmp-dribbble-sat-3"
                  cx="6"
                  cy="6.5"
                  r="1.1"
                  fill="currentColor"
                />
                <circle
                  className="cmp-dribbble-sat-4"
                  cx="22"
                  cy="21.5"
                  r="1.2"
                  fill="currentColor"
                />
              </svg>
            </div>

            <div
              style={{
                flex: 1,
                minWidth: 0,
                fontSize: '12.5px',
                lineHeight: '1.45',
                color: '#334155',
              }}
            >
              <div
                style={{ fontWeight: 700, fontSize: '13px', color: '#0f172a', marginBottom: '3px' }}
              >
                AI Generation in Progress
              </div>
              <div>
                Leaving right now will{' '}
                <strong style={{ color: '#b91c1c' }}>cancel the active AI generation</strong> and
                discard unfinalized strategy or content drafts.
              </div>
            </div>
          </div>

          <p style={{ margin: 0, fontSize: '13px', color: '#64748b', lineHeight: '1.45' }}>
            Are you sure you want to exit to the Campaigns Catalog, or would you like to stay and
            let AI complete the synthesis?
          </p>
        </div>

        {/* Modal Footer */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '12px 20px',
            borderTop: '1px solid #e2e8f0',
            background: '#f8fafc',
          }}
        >
          <button
            type="button"
            onClick={onClose}
            style={{
              fontWeight: 600,
              padding: '8px 16px',
              fontSize: '12.5px',
              borderRadius: '6px',
              cursor: 'pointer',
              background: '#2563eb',
              color: '#ffffff',
              border: '1px solid #1d4ed8',
              boxShadow: '0 1px 2px rgba(37, 99, 235, 0.2)',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              transition: 'background-color 0.15s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#1d4ed8';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#2563eb';
            }}
          >
            <i className="fas fa-arrow-left" style={{ fontSize: '11px' }} /> Stay &amp; Wait for AI
          </button>

          <button
            type="button"
            onClick={onConfirmLeave}
            style={{
              fontWeight: 600,
              padding: '8px 14px',
              fontSize: '12.5px',
              borderRadius: '6px',
              background: '#ffffff',
              color: '#dc2626',
              border: '1px solid #fca5a5',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              transition: 'all 0.15s ease',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = '#fef2f2';
              e.currentTarget.style.borderColor = '#ef4444';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = '#ffffff';
              e.currentTarget.style.borderColor = '#fca5a5';
            }}
          >
            <i className="fas fa-sign-out-alt" style={{ fontSize: '11px' }} /> Leave &amp; Interrupt
            AI
          </button>
        </div>
      </div>
    </div>
  );
}
